import { track } from '@mc/track-event'
import { getAccountId, getAccountEmail } from '@mc/user-info'
import { ShareContextData } from './provider/ShareContext'

export const advocateData = {
  advocate_id: getAccountId(),
  advocate_email: getAccountEmail(),
}

export const EVENTS = {
  NATIVE_SHARE: 'Mobile Share Sheet Viewed',
  MOBILE_SHARE_MODAL_VIEWED: 'Mobile Share Modal Viewed',
  SHARE_EXTERNALLY_CLICKED: 'Share Externally Clicked',
  SHARE_CLICKED: 'Share Clicked',
  SHARE_MODAL_VIEWED: 'Share Modal Viewed',
  SHARE_MODAL_CLICKED: 'Share Modal Clicked',
  SHARE_MODAL: 'Mobile Share Modal Viewed',
}

export const trackShareExternallyClicked = ({
  channel,
  link,
  shareData = {},
  emails,
}: {
  channel: string
  link: string
  shareData: Partial<ShareContextData>
  emails?: string[]
}) => {
  const { course, chapter, source, gem } = shareData
  const { slug: courseSlug } = course || {}
  const { slug: chapterSlug } = chapter || {}
  const { slug: gemSlug } = gem || {}

  const params = {
    shareLink: link,
    page: courseSlug,
    lesson: chapterSlug,
    gem: gemSlug,
    source,
    channel,
    ...advocateData,
    ...(emails && { emails, emailCount: emails.length }),
  }

  track(EVENTS.SHARE_EXTERNALLY_CLICKED, params)
}

export const trackShareBtnClicked = ({
  copy,
  page,
  shareData,
}: {
  copy: string
  page: string
  shareData: ShareContextData & { course: { slug: string } }
}) => {
  const {
    course: { slug: classSlug },
    chapter,
    source,
  } = shareData
  const params: Record<string, string | number | null | undefined> = {
    buttonCopy: copy,
    page: classSlug,
    pageType: page,
    source,
    ...advocateData,
  }

  if (chapter) {
    params.lesson = chapter.slug
  }

  track(EVENTS.SHARE_CLICKED, params)
}

export const trackShareModalClicked = ({
  action,
  source,
}: {
  action: string
  source: string
}) => {
  track(EVENTS.SHARE_MODAL_CLICKED, { action, source })
}

export const trackShareModalViewed = ({
  page,
  lesson,
  source,
}: {
  page?: string | null
  lesson?: string | null
  source?: string | null
}) => {
  track(EVENTS.SHARE_MODAL_VIEWED, { page, lesson, source, ...advocateData })
}

export const trackMobileShareViewed = ({
  native = false,
  source,
  page,
  lesson,
}: {
  native: boolean
  source: string
  page: string
  lesson?: string | null
}) => {
  const trackName = native ? EVENTS.NATIVE_SHARE : EVENTS.SHARE_MODAL
  track(trackName, { source, page, lesson })
}
